import React, { useEffect, useState, useRef } from "react";
import "./Login.css";
import loginImage from "../../assets/images/back1234.png";
import vectorImage from "../../assets/images/Logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { env } from "../../environment.js";
import genAI from "../../assets/images/UPL_Genie_logo 1.svg";
import PoweredBy from "../../assets/images/PoweredBy.svg";
import { encrypted } from "../../utils/Utility.jsx";
import { useEventEmitter } from "../../contexts/EventEmmiter.js";

function Login() {
  const [loginState, setLoginState] = useState(true);
  const [isLanding, setIsLanding] = useState(false);
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();
  const abortTimeout = useRef(false);
  useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

  useEffect(() => {
    checkAndLoginUser();
  }, [location.search]);

  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
  
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");
  
    if (code) return;
  
    const timer = setTimeout(() => {
      if (!abortTimeout.current && !isLanding) {
        fetchAuthenticatedAPI();
      }
    }, 5000);
  
    return () => clearTimeout(timer);
  }, []);
  
  

  const checkAndLoginUser = () => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");
    if (code) {
      setLoginState(false);
      fetchUserTokenAndAuthenticate(code);
    }
  };

  const fetchUserTokenAndAuthenticate = async (code) => {
    try {
      const response = await axios.post(
        `${env.baseURL}/auth/azure/authenticate`,
        {
          encryptedBody: encrypted.encrypt(JSON.stringify({ code: code })),
        }
      );
      let item = JSON.parse(encrypted.decrypt(response.data.encryptedBody));
      localStorage.setItem("token", item.token);
      localStorage.setItem("LoggedInDetails", JSON.stringify(item.app_user));
      localStorage.setItem("isPolicy", JSON.stringify(item.flag));
      localStorage.setItem("isLogin", true);
      navigate("/dashboard");
      setLoginState(true);
      setIsLanding(false);
      localStorage.setItem('logout',false)
      toast.success("You are successfully logged in");
    } catch (error) {
      let errorItem = JSON.parse(encrypted.decrypt(error?.response?.data?.encryptedBody));
      setIsLanding(true);
      setLoginState(true);
      abortTimeout.current = true;
      toast.error(errorItem?.detail);
    } finally {
      setLoginState(false); // Ensure the loading state is reset
    }
  };

  const fetchAuthenticatedAPI = () => {
    axios
      .get(`${env.baseURL}/auth/azure/auth-info`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        let data = JSON.parse(encrypted.decrypt(response.data.encryptedBody));
        ssoSignIn(data);
      })
      .catch((error) => {
        setIsLanding(true);
        abortTimeout.current = true;
        setLoginState(true);
        console.error("There was an error!", error);
      });
  };

  const { subscribe } = useEventEmitter();
  useEffect(() => {
    const unsubscribe = subscribe("logout", (data) => {
      setIsLanding(true);
      abortTimeout.current = true;
      setLoginState(true);
    });
    return () => unsubscribe();
  }, [subscribe]);

  const ssoSignIn = (props) => {
    const item = props;
    const loginUrl = item.login_url;
    const logOutUrl = item.logout_url;
    if (loginUrl) {
      localStorage.setItem("loginUrl", loginUrl);
      window.location.href = loginUrl;
    }
    if (logOutUrl) {
      localStorage.setItem("logOutUrl", logOutUrl);
    }
  };

  useEffect(() => {
    const isLogout = localStorage.getItem('logout');
    if (isLogout === "true") {
      setIsLanding(true);
      abortTimeout.current = true;
      localStorage.removeItem('logout');
    }
  }, []);

  return (
    <>
      <ToastContainer
        closeButton={true}
        autoClose={1000}
        position="top-right"
      />
      {isLanding ? (
        // Landing Screen with Login Button
        <div
          className="parentLoginContainer"
         style={{
          backgroundImage: !isMobile ? `url(${loginImage})` : "",
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "100%",
            overflow: "hidden",
          }}
        >
          <div className="parentTextContainer">
            <div className="textContainer">
              <div className="welcomeContainer">
                Welcome to
              </div>
              <div>
                <img
                  width="100%"
                  height="100%"
                  src={vectorImage}
                  alt="vector"
                />
              </div>
              <div className="loginTo">
                <span>Log in to continue</span>
              </div>
              <div className="loginButtonContainer">
                <button
                  className="buttonAlignment"
                  onClick={fetchAuthenticatedAPI}
                >
                  Log In
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : !loginState ? (
        // Please Wait Screen
        <div className="loginWaitContainer">
          <div className="sidebar-profile-sub-title">
            Please wait a while...
          </div>
        </div>
      ) : (
        // Welcome Screen
        <div className="loginWaitContainer">
          <div className="dashboard-profile-container">
            <span>
              <div className="sidebar-profile-sub-title">Welcome to</div>
              <div>
                <img
                  style={{ width: "100%", height: "100%" }}
                  src={genAI}
                  alt=""
                />
              </div>
              <div className="loader-wrapper">
                <div className="loader-bar">
                  <div className="loader-fill"></div>
                </div>
              </div>
            </span>
            <div className="powered">
              <div className="powered-title">Powered by</div>
              <div>
                <img src={PoweredBy} alt="" />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Login;
